// extracted by mini-css-extract-plugin
export default {"header":"Donate_header__9fMLO"};